<template>
	<v-content class="fill-height">
		<ExplorerScreen v-if="$store.getters.activescreen==='explorer'" />
		<AssetTypeScreen v-else-if="$store.getters.activescreen==='assettype'" />
		<DashboardScreen v-else />
	</v-content>
</template>
<script>
import DashboardScreen from "./DashboardScreen";
import ExplorerScreen from "./ExplorerScreen";
import AssetTypeScreen from "./AssetTypeScreen";
export default {
	components: {
		DashboardScreen,
		ExplorerScreen,
		AssetTypeScreen
	}
};
</script>
